import _ from "lodash";
import Accessor from "./Accessor";

class ZJSObject {

  /**
   * 
   * @param {*} obj 
   * @param {Boolean} nested 
   * @returns 
   */
  static RemoveUndefined(obj, nested = false){
    let newObj = {};
    Object.keys(obj).forEach((key) => {
      if (nested && obj[key] === Object(obj[key])) {
        newObj[key] = this.RemoveUndefined(obj[key], nested);
      } else if (obj[key] !== undefined) {
        newObj[key] = obj[key];
      }
    });
    return newObj;
  }

  /**
   * 
   * @param {*[]} arrayOfValues 
   */
  static ValuesToKeys(arrayOfValues){
    let rtn = {};
    _.map(arrayOfValues, (o, i) => {
      rtn[o] = true;
    });
    return rtn;
  }

  /**
   * 
   * @param {*} objectOfKeys 
   */
  static KeysToValues(objectOfKeys){
    let rtn = [];
    if(objectOfKeys){
      Object.keys(objectOfKeys).forEach((key) => {
        rtn.push(key);
      });
    }
    return rtn;
  }

  static isIdentical(obj1, obj2){
    let kv1 = Accessor.NestedToKeyValuePairs(obj1);
    let kv2 = Accessor.NestedToKeyValuePairs(obj2);
    
    let keys1 = Object.keys(kv1);
    let keys2 = Object.keys(kv2);
    if(keys1.length !== keys2.length) return false;
    for(let i=0; i<keys1.length; i++){
      let key = keys1[i];
      if(kv1[key] !== kv2[key]) return false;
    }
    return true;
  }

}

export default ZJSObject;